import type { FC } from "react";

import { useTextSeparatorWithDirectionalMark } from "@ui/hooks/useTextSeparatorWithDirectionalMark";

import type { Address } from "@jti/fe-common";

type AddressStreetInfoSaudiArabiaVariantProps = Partial<Address>;

export const AddressStreetInfoSaudiArabiaVariant: FC<AddressStreetInfoSaudiArabiaVariantProps> = ({
  shortAddress,
  postcode,
  provinceName,
  city,
  district,
  streetName,
  streetAdditional,
  countryName,
}) => {
  const { joinWithSeparator } = useTextSeparatorWithDirectionalMark();

  const secondRow = joinWithSeparator(postcode, provinceName, city, district);
  const thirdRow = joinWithSeparator(streetName, streetAdditional);

  return (
    <>
      {shortAddress && <div>{shortAddress}</div>}
      {secondRow && <div>{secondRow}</div>}
      {thirdRow && <div>{thirdRow}</div>}
      {countryName && <div>{countryName}</div>}
    </>
  );
};
